<div class="security-tag">
  <div class="security-tag-container" *ngFor="let tag of tags">
    <div class="security-tag-container-key">
      {{ tag.key }}
    </div>
    <div>
      <a class="security-tag-container-value" *ngIf="tag.link" [href]="tag.link" target="_blank">{{ tag.value }}</a>
      <div class="security-tag-container-value" *ngIf="!tag.link">
        {{ tag.value }}
      </div>
    </div>
  </div>
</div>
